import React from 'react';

const VehicleDetailsSection = ({ formData, errors, handleChange }) => {
  // Only show for vehicle loans
  if (!(formData.loanCategory === 'VEHICLE_LOAN' || formData.loanSubcategory?.includes('CAR') || formData.loanSubcategory?.includes('WHEELER'))) {
    return null;
  }

  return (
    <section className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
      <h3 className="text-2xl font-bold text-gray-800 mb-4 sm:mb-4 flex items-center border-b pb-2 sm:pb-3">
        <span className="bg-blue-100 text-blue-600 w-8 h-8 rounded-full flex items-center justify-center mr-3 text-base">5</span>
        Vehicle Details
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-4">
        <div>
          <label className="block text-base font-semibold text-gray-700 mb-2">
            1. Registration Number
          </label>
          <input
            type="text"
            name="vehicleRegistrationNumber"
            value={formData.vehicleRegistrationNumber}
            onChange={handleChange}
            placeholder="e.g. MH-12-AB-1234"
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none"
          />
        </div>

        <div>
          <label className="block text-base font-semibold text-gray-700 mb-2">
            2. Vehicle Type
          </label>
          <select
            name="vehicleType"
            value={formData.vehicleType}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none bg-white"
          >
            <option value="">Select Vehicle Type</option>
            <option value="Car">Car</option>
            <option value="Commercial Vehicle">Commercial Vehicle</option>
            <option value="Two Wheeler">Two Wheeler</option>
            <option value="Three Wheeler">Three Wheeler</option>
          </select>
        </div>

        <div>
          <label className="block text-base font-semibold text-gray-700 mb-2">
            3. Vehicle Model
          </label>
          <input
            type="text"
            name="vehicleModel"
            value={formData.vehicleModel}
            onChange={handleChange}
            placeholder="e.g. Maruti Swift VXI"
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none"
          />
        </div>

        <div>
          <label className="block text-base font-semibold text-gray-700 mb-2">
            4. Fuel Type
          </label>
          <select
            name="vehicleFuelType"
            value={formData.vehicleFuelType || ''}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none bg-white"
          >
            <option value="">Select Fuel Type</option>
            <option value="Petrol">Petrol</option>
            <option value="Petrol + CNG">Petrol + CNG</option>
            <option value="EV">EV</option>
            <option value="Diesel">Diesel</option>
          </select>
        </div>

        <div>
          <label className="block text-base font-semibold text-gray-700 mb-2">
            5. Manufacturing Year
          </label>
          <input
            type="month"
            name="vehicleManufacturingYear"
            value={formData.vehicleManufacturingYear}
            onChange={handleChange}
            max={new Date().toISOString().slice(0, 7)}
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none"
          />
          {errors.vehicleManufacturingYear && <span className="text-red-500 text-sm mt-1 block">{errors.vehicleManufacturingYear}</span>}
        </div>

        <div>
          <label className="block text-base font-semibold text-gray-700 mb-2">
            6. Number of Owners
          </label>
          <select
            name="vehicleNumberOfOwners"
            value={formData.vehicleNumberOfOwners}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none bg-white"
          >
            <option value="">Select Number of Owners</option>
            <option value="1st Owner">1st Owner (New)</option>
            <option value="2nd Owner">2nd Owner</option>
            <option value="3rd Owner">3rd Owner</option>
            <option value="4th Owner or More">4th Owner or More</option>
          </select>
        </div>

        <div>
          <label className="block text-base font-semibold text-gray-700 mb-2">
            7. KM Reading (Odometer)
          </label>
          <input
            type="number" onWheel={(e) => e.target.blur()}
            name="vehicleKmReading"
            value={formData.vehicleKmReading}
            onChange={handleChange}
            placeholder="e.g. 45000"
            min="0"
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none"
          />
          {errors.vehicleKmReading && <span className="text-red-500 text-sm mt-1 block">{errors.vehicleKmReading}</span>}
        </div>

        <div>
          <label className="block text-base font-semibold text-gray-700 mb-2">
            8. Purchase Price (₹)
          </label>
          <input
            type="number" onWheel={(e) => e.target.blur()}
            name="vehiclePurchasePrice"
            value={formData.vehiclePurchasePrice}
            onChange={handleChange}
            placeholder="e.g. 500000"
            min="0"
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none"
          />
          {errors.vehiclePurchasePrice && <span className="text-red-500 text-sm mt-1 block">{errors.vehiclePurchasePrice}</span>}
        </div>

        <div className="md:col-span-2">
          <label className="block text-base font-semibold text-gray-700 mb-2">
            9. Loan Amount Required (₹)
          </label>
          <input
            type="number" onWheel={(e) => e.target.blur()}
            name="vehicleLoanAmountRequired"
            value={formData.vehicleLoanAmountRequired}
            onChange={handleChange}
            placeholder="e.g. 400000"
            min="0"
            className="w-full px-3 py-2 rounded-lg border-2 border-orange-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none"
          />
          {errors.vehicleLoanAmountRequired && <span className="text-red-500 text-sm mt-1 block">{errors.vehicleLoanAmountRequired}</span>}
        </div>

        {/* RC & Insurance Box */}
        <div className="md:col-span-2 bg-gradient-to-r from-blue-50/70 to-emerald-50/70 p-4 sm:p-5 rounded-2xl border border-blue-100 space-y-4">
          <h4 className="font-bold text-gray-800 flex items-center gap-2 text-lg">
            <span className="bg-blue-100 text-blue-600 p-1.5 rounded-lg text-sm">📋</span> RC & Insurance Details
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* RC Toggle Box */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center justify-between">
              <div>
                <label className="block text-sm font-bold text-gray-700">9. RC Available (Registration Certificate)</label>
                <span className="text-xs text-gray-500">Default: OFF (No)</span>
              </div>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => handleChange({ target: { name: 'hasRc', type: 'checkbox', checked: !formData.hasRc } })}
                  className={`relative inline-flex h-7 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                    formData.hasRc ? 'bg-green-600' : 'bg-gray-300'
                  }`}
                >
                  <span
                    className={`pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                      formData.hasRc ? 'translate-x-7' : 'translate-x-0'
                    }`}
                  />
                </button>
                <span className={`text-sm font-bold min-w-[32px] ${formData.hasRc ? 'text-green-600' : 'text-gray-500'}`}>
                  {formData.hasRc ? 'Yes' : 'No'}
                </span>
              </div>
            </div>

            {/* Insurance Toggle Box */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center justify-between">
              <div>
                <label className="block text-sm font-bold text-gray-700">10. Insurance Available</label>
                <span className="text-xs text-gray-500">Default: OFF (No)</span>
              </div>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => handleChange({
                    target: {
                      name: 'vehicleInsurance',
                      type: 'text',
                      value: formData.vehicleInsurance === 'yes' ? 'no' : 'yes'
                    }
                  })}
                  className={`relative inline-flex h-7 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                    formData.vehicleInsurance === 'yes' ? 'bg-green-600' : 'bg-gray-300'
                  }`}
                >
                  <span
                    className={`pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                      formData.vehicleInsurance === 'yes' ? 'translate-x-7' : 'translate-x-0'
                    }`}
                  />
                </button>
                <span className={`text-sm font-bold min-w-[32px] ${formData.vehicleInsurance === 'yes' ? 'text-green-600' : 'text-gray-500'}`}>
                  {formData.vehicleInsurance === 'yes' ? 'Yes' : 'No'}
                </span>
              </div>
            </div>
          </div>

          {formData.vehicleInsurance === 'yes' && (
            <div className="bg-white p-4 rounded-xl border border-green-200 mt-2">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Insurance IDV Amount (₹) :
              </label>
              <input
                type="number" onWheel={(e) => e.target.blur()}
                name="vehicleInsuranceIdvAmount"
                value={formData.vehicleInsuranceIdvAmount || ''}
                onChange={handleChange}
                placeholder="e.g., 450000"
                min="0"
                className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all outline-none"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default VehicleDetailsSection;
